/**
 * API configuration constants
 */
export const API_TIMEOUT = 10000; // 10 seconds
export const API_RETRY_COUNT = 1;
export const API_RETRY_DELAY = 1000; // 1 second
